import { Component, DestroyRef, inject, OnInit} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ActivatedRoute, Router } from '@angular/router'
import { NavbarService } from '@app/core/layout/services/navbar.service'
import { AuthService } from '@app/core/auth/services/auth.service'
import { TranslateService } from '@ngx-translate/core'


@Component({ selector: 'app-help-center', templateUrl: './help-center.component.html', styleUrls: ['./help-center.component.css'], standalone: false })
export class HelpCenterComponent implements OnInit {
  private destroyRef = inject(DestroyRef)
  randomTipTitle: string = ''
  randomTipDescription: string = ''
  activeTab: number = 0

  private readonly tabSlugs: Record<number, string> = {
    0: 'faq',
    1: 'files',
    2: 'user-manual',
    3: 'api-reference',
  }

  private readonly slugToTab: Record<string, number> = {
    faq: 0,
    files: 1,
    'user-manual': 2,
    'api-reference': 3,
  }

  constructor(
    private navbarService: NavbarService,
    private authService: AuthService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  get isClientAdmin(): boolean {
    return this.authService.user?.role?.isClientAdmin ?? false
  }

  ngOnInit(): void {
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      const slug = params['tab'] as string
      const tabValue = this.slugToTab[slug] ?? 0
      const isAdminOnly = tabValue === 2 || tabValue === 3
      if (isAdminOnly && !this.isClientAdmin) {
        this.router.navigate(['..', 'faq'], { relativeTo: this.route })
        return
      }
      this.activeTab = tabValue
    })
    this.assignTitle()
    this.assignRandomTip()
  }

  onTabChange(value: number | string): void {
    const numValue = Number(value)
    const slug = this.tabSlugs[numValue] ?? 'faq'
    this.router.navigate(['..', slug], { relativeTo: this.route })
  }


  assignTitle() {
    this.navbarService.title.next(this.translate.instant('HELP_CENTER.PAGE_TITLE'))
    this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((_el) => {
      this.navbarService.title.next(this.translate.instant('HELP_CENTER.PAGE_TITLE'))
      this.assignRandomTip()
    })
  }

  assignRandomTip() {
    // These two keys hold string ARRAYS in the i18n files (rare; instant is typed for string values)
    const titles = this.translate.instant('BUSINESS_DETAILS.TOOLTIP.TITLES') as unknown as string[]
    const descriptions = this.translate.instant('BUSINESS_DETAILS.TOOLTIP.DESCRIPTIONS') as unknown as string[]

    if (!Array.isArray(titles) || !Array.isArray(descriptions) || !titles.length || !descriptions.length) {
      this.randomTipTitle = ''
      this.randomTipDescription = ''
      return
    }

    const maxIndex = Math.min(titles.length, descriptions.length) - 1
    const randomIndex = Math.floor(Math.random() * (maxIndex + 1))

    this.randomTipTitle = titles[randomIndex]
    this.randomTipDescription = descriptions[randomIndex]
  }
}
